import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SnackService } from './snack.service';
import { serverurl } from '../../environments/environment';
import { BusinessType, IdeaType, IndustryType } from '../interfaces/responsedata.ts/datatypes';
import { Category, CategoryTree, StreamOrderItem } from '../interfaces/responsedata.ts/generic-streams';
import { inject } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class AppdataService {
    http = inject(HttpClient);
    snack = inject(SnackService);

    industryTypes: IndustryType[] = [];
    ideaTypes: IdeaType[] = [];
    businessTypes: BusinessType[] = [];

    allowedFileTypes: any[] = [];
    licenseTypes: any[] = [];
    roles: any[] = [];
    systemLanguages: any[] = [];
    intentionRoles: any[] = [];
    tags: any[] = [];
    tagGroups: any[] = [];

    streamCategories = new BehaviorSubject<Category[]>([]);
    tracks = new BehaviorSubject<any>(null);
    showHeaderBackButton = new BehaviorSubject<boolean>(false);


    async loadAppData() {
        Promise.all(
            [
                await this.loadIndustryData(),
                await this.loadLicenseTypes(),
                await this.loadRoles(),
                await this.loadSystemLanguages(),
                await this.loadIntentionRoles(),
                await this.loadAllTags(),
                await this.loadTagCategories(),
                await this.loadCatsAndStreams(),
                await this.loadIdeaTypeData(),
                await this.loadBusinessTypeData(),
            ],
        );
    }

    async loadStructuredCategoriesAndStreams(): Promise<false | StreamOrderItem[]> {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/data/categories/structured?t=' + new Date().getTime()).subscribe({
                next: (data: any) => {
                    resolve(data as StreamOrderItem[]);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadStepsByStreamId(streamId: any) {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/streams/steps/' + streamId).subscribe({
                next: (data: any) => {
                    resolve(data);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }


    async loadCatsAndStreams() {
        await this.getStreamCategories();
        // await this.loadTracksAndStreams();
    }
    async loadTracksAndStreams() {
        // ToDo: Delete with new TrackRun
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/data/tracks').subscribe({
                next: async (data: any) => {
                    // console.log("TRACKS", data);

                    this.tracks.next(data);
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async getStreamCategories() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/data/categories').subscribe({
                next: async (data: any) => {
                    // console.log('Cats', data);

                    for await (let cat of data) {
                        try {
                            cat.tags = JSON.parse(cat.tags);
                        } catch (error) { }
                    }
                    this.streamCategories.next(data as Category[]);
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }


    async loadAllTags() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/data/tags').subscribe({
                next: async (data: any) => {
                    this.tags = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadTagCategories() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/public/data/taggroups.json').subscribe({
                next: (data: any) => {
                    this.tagGroups = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadKnowledgeHubAllowedTypes() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/knowledgehub/allowedfiletypes').subscribe({
                next: (data: any) => {
                    this.allowedFileTypes = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadIndustryData() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/public/data/industry.json').subscribe({
                next: (data: any) => {
                    this.industryTypes = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadBusinessTypeData() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/public/data/businesstypes.json').subscribe({
                next: (data: any) => {
                    this.businessTypes = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadIdeaTypeData() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/public/data/ideatypes.json').subscribe({
                next: (data: any) => {
                    this.ideaTypes = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }

    async loadIntentionRoles() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/public/data/intentionroles.json').subscribe({
                next: (data: any) => {
                    this.intentionRoles = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadLicenseTypes() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/public/data/license.json').subscribe({
                next: (data: any) => {
                    this.licenseTypes = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }

    async loadRoles() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/public/data/roles.json').subscribe({
                next: async (data: any) => {
                    this.roles = await data.filter((r: any) => r.type == 'USER');
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }

    async loadSystemLanguages() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/public/data/languages.json').subscribe({
                next: (data: any) => {
                    this.systemLanguages = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
}
